import { ConsentWorkflow, RestartConsentForm, RestartConsentFormResponse } from '@/api/dtos';
import { OnlinePatientManagementContext } from '@ngt/opms';
import { useCallback, useContext } from 'react';

export interface UseRestartConsentFormOptions {
    revalidateForm?: () => Promise<unknown>;
    refreshPatient?: () => Promise<unknown>;
    refreshSummary?: () => Promise<unknown>;
}

const useRestartConsentForm = ({
    revalidateForm,
    refreshPatient,
    refreshSummary
}: UseRestartConsentFormOptions = {}) => {
    const { serviceStackClient } = useContext(OnlinePatientManagementContext);

    return useCallback(async (request: RestartConsentForm) => {
        const response = await serviceStackClient.post<RestartConsentFormResponse>(request);

        await Promise.all([
            revalidateForm?.(),
            request.workflow === ConsentWorkflow.EConsent ? refreshPatient?.() : undefined,
            refreshSummary?.()
        ]);

        return response;
    }, [serviceStackClient, revalidateForm, refreshPatient, refreshSummary]);
};

export default useRestartConsentForm;
